/**
 *
 *  Organizations/Show/Events
 *
 */

import React, { useState } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import { format, subDays, startOfYear } from 'date-fns'
// import styled from '@emotion/styled'

// GraphQL
import useQuery from 'components/UseQuery'
import { gql } from '@apollo/client'

// Components
import DateRangeDropdown from 'components/DateRange/Dropdown'
import EventsTable from 'components/Organizations/Show/Events/Table'
import DropDownMenu from 'components/DropDownMenu'

const GET_ORGANIZATION = gql`
	query organization($id: ID) {
		org: organization(id: $id) {
			users {
				id
				full_name
			}
		}
	}
`

const default_filters = {
	topic_type: 'all',
	start_date: startOfYear(new Date()),
	end_date: subDays(new Date(), 1),
	user_ids: [],
}

function Events({ organization }) {
	const [filters, setFilters] = useState({
		...default_filters,
	})

	const { start_date, end_date, topic_type } = filters

	const {
		data: { org },
		loading,
	} = useQuery(GET_ORGANIZATION, {
		variables: { id: organization.id, ...filters },
		channels: [organization.id],
		default_data: {
			org: {
				users: [],
			},
		},
		skip: !organization.id,
	})

	const resetFilters = () => {
		setFilters({ ...default_filters })
	}

	return (
		<div>
			<div className="d-flex justify-content-between mb-2">
				<div className="d-flex">
					<DateRangeDropdown
						CustomButton={(props) => (
							<button className="btn btn-primary" {...props}>
								<span>
									Time Range: {format(start_date, 'MM/dd/yyyy')} – {format(end_date, 'MM/dd/yyyy')}
								</span>
							</button>
						)}
						start_date={start_date}
						end_date={end_date}
						setRangeDate={(new_start_date, new_end_date) =>
							setFilters({ ...filters, start_date: new_start_date, end_date: new_end_date })
						}
						disabled={loading}
					/>

					<DropDownMenu
						Button={
							<span>
								Topic Type:{' '}
								{topic_type === 'all'
									? 'All'
									: topic_type === 'tailor_made'
									? 'Custom-Crafted Only'
									: 'Performance-Based Only'}
							</span>
						}
						button_props={{ className: 'btn btn-primary ml-2' }}
					>
						<ul className="list-group">
							<li className="list-group-item">
								<button
									type="button"
									className="btn-unstyled"
									onClick={() => setFilters({ ...filters, topic_type: 'all' })}
								>
									All
								</button>
							</li>
							<li className="list-group-item">
								<button
									type="button"
									className="btn-unstyled"
									onClick={() => setFilters({ ...filters, topic_type: 'tailor_made' })}
								>
									Custom-Crafted Only
								</button>
							</li>
							<li className="list-group-item">
								<button
									type="button"
									className="btn-unstyled"
									onClick={() => setFilters({ ...filters, topic_type: 'ready_made' })}
								>
									Performance-Based Only
								</button>
							</li>
						</ul>
					</DropDownMenu>
				</div>

				<button className="btn btn-warning align-self-end" onClick={resetFilters}>
					Reset Page Filters
				</button>
			</div>

			<EventsTable
				organization_id={organization.id}
				filters={filters}
				setUserIds={(user_ids) => setFilters({ ...filters, user_ids })}
				users={org.users}
			/>
		</div>
	)
}

Events.propTypes = {
	organization: PropTypes.string,
}

export default Events
